import { useQuery } from '@tanstack/react-query'
import { listBlogPosts } from '../api/blogs'
import { BLOG_POST_STATUS } from '../constants/api'
import { QUERY_KEYS } from '../constants/query'
import { toApiMessage } from '../helpers/api-error'
import {
  mapBlogPostCard,
  sortBlogPostsByPublishedAt,
  type BlogPostCard,
} from '../helpers/mapContent'

type BlogPostsState = {
  posts: BlogPostCard[]
  loading: boolean
  error: string | null
}

export function useBlogPosts(): BlogPostsState {
  const blogsQuery = useQuery({
    queryKey: QUERY_KEYS.blogs,
    queryFn: () => listBlogPosts(BLOG_POST_STATUS.published),
  })
  const error = blogsQuery.error
    ? toApiMessage(blogsQuery.error, 'Failed to load blog posts')
    : null

  return {
    posts: sortBlogPostsByPublishedAt(blogsQuery.data ?? []).map(mapBlogPostCard),
    loading: blogsQuery.isPending && !blogsQuery.data && !error,
    error,
  }
}
